import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import InvoiceView from 'screens/Invoices/Invoice/InvoiceView';
import useInvoiceFlags from 'screens/Invoices/redesign/hooks/useInvoiceFlags';
import { paths } from 'routes/paths';

/**
 * Route guard for the legacy `/invoices/:id/:view` URL.
 *
 * When the redesign flag is active (FR-023) the full-page detail route is
 * superseded by the side-panel in the redesigned landing. Any direct link to
 * `/app/invoices/:id/view` is transparently redirected to `/app/invoices` with
 * `{ selectedInvoiceId: id }` in route state so the landing can pre-open the
 * correct row's detail panel.
 *
 * When the flag is off the legacy `<InvoiceView>` renders as before.
 */
const InvoiceViewGuard: React.FC = () => {
  const { id } = useParams<{ id: string; view: string }>();
  const { feInvoicesActive } = useInvoiceFlags();

  if (feInvoicesActive) {
    return (
      <Redirect
        to={{
          pathname: paths.invoices,
          state: { selectedInvoiceId: id }
        }}
      />
    );
  }

  return <InvoiceView />;
};

export default InvoiceViewGuard;
